
export const getScreenLevelErrorStatus = (state) => state.screenLevelErrorStatus;

export const getAppLevelErrorStatus = (state) => state.appLevelErrorStatus;

export const getIsRetriableGetInProgress = (state) => state.retriableGetInProgress.length > 0;

export const getRetryGetRequestActionName = (state) => state.retryGetRequestActionName;

export const getAudioSavingErrorStatus = state => state.audioSavingErrorStatus;

export const getIsBackgroundRetryInProgress = state => state.isBackgroundRetryInProgress;

export const getBackgroundRetryId = state => state.backgroundRetryId;
